import {
  instance as axios,
  setJwtToken,
  setMultiPartHeader,
} from "../../config/axiosInstance";

// Fetch all system-generated metrics (base metrics)
export const fetchSystemGeneratedMetricsApi = async (data) => {
  const endPoint = `/admin/dashboard-matrix/system-metrics` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

// Fetch all metrics for Dashboard Matrix Analytics
export const fetchDashboardMatrixMetricsApi = async (data) => {
  const endPoint = `/admin/dashboard-matrix/metrics` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

// Fetch User Lifecycle Metrics
export const fetchUserLifecycleMetricsApi = async (data) => {
  const endPoint = `/admin/dashboard-matrix/user-lifecycle` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

// Fetch Engagement Metrics
export const fetchEngagementMetricsApi = async (data) => {
  const endPoint = `/admin/dashboard-matrix/engagement` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

// Fetch Conversion & Funnel Metrics
export const fetchConversionMetricsApi = async (data) => {
  const endPoint = `/admin/dashboard-matrix/conversion` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

// Fetch Revenue & Wallet Metrics
export const fetchRevenueMetricsApi = async (data) => {
  const endPoint = `/admin/dashboard-matrix/revenue` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

// Fetch Retention & Cohort Metrics
export const fetchRetentionMetricsApi = async (data) => {
  const endPoint = `/admin/dashboard-matrix/retention` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

// Fetch Session & Time Metrics
export const fetchSessionMetricsApi = async (data) => {
  const endPoint = `/admin/dashboard-matrix/session` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

// Fetch Platform Health Metrics
export const fetchPlatformHealthMetricsApi = async (data) => {
  const endPoint = `/admin/dashboard-matrix/platform-health` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

// Fetch date-wise system metrics for chart
export const fetchDateWiseSystemMetricsApi = async (data) => {
  const endPoint = `/admin/dashboard-matrix/date-wise-metrics` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

